module.exports = __webpack_public_path__ + "img/hair_back_female_wavy_short.5a6e68a3.png";